import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-camera-fill',
    title: 'Security Camera Installation',
    description: 'HD and 4K wired or wireless cameras installed at optimal angles inside and outside your property for complete coverage with night vision support.',
    href: '/services/cybersecurity',
    tag: 'Most Popular',
    image: 'https://public.readdy.ai/ai/img_res/988198e90195fcbb127d9566fe0d7ab1.jpg',
  },
  {
    icon: 'ri-vidicon-fill',
    title: 'Surveillance Systems (CCTV)',
    description: 'Complete CCTV system design and installation including NVR/DVR recorders, monitors, and remote smartphone and computer access for 24/7 surveillance.',
    href: '/services/cybersecurity',
    tag: null,
    image: 'https://readdy.ai/api/search-image?query=CCTV%20surveillance%20system%20monitor%20screen%20showing%20multiple%20camera%20feeds%20security%20control%20room%20bright%20modern%20professional%20office%20environment&width=600&height=400&seq=svc-cctv1&orientation=landscape',
  },
  {
    icon: 'ri-alarm-warning-fill',
    title: 'Alarm Systems',
    description: 'Intrusion detection, door and window sensors, motion detectors, glass break sensors, and 24/7 professional monitoring options for complete protection.',
    href: '/services/cybersecurity',
    tag: null,
    image: 'https://readdy.ai/api/search-image?query=modern%20home%20alarm%20system%20control%20panel%20keypad%20installed%20on%20white%20wall%20residential%20home%20interior%20clean%20bright%20modern%20design%20security&width=600&height=400&seq=svc-alarm1&orientation=landscape',
  },
  {
    icon: 'ri-door-lock-fill',
    title: 'Access Control Systems',
    description: 'Keypad entry, key fob, card reader, and biometric access control for offices, apartment buildings, warehouses, and commercial properties.',
    href: '/services/cybersecurity',
    tag: 'Commercial',
    image: 'https://readdy.ai/api/search-image?query=electronic%20door%20access%20control%20panel%20keypad%20entry%20system%20modern%20office%20building%20glass%20door%20professional%20installation%20clean%20bright&width=600&height=400&seq=svc-access1&orientation=landscape',
  },
  {
    icon: 'ri-home-smart-fill',
    title: 'Smart Home Automation',
    description: 'Integrated smart home security with video doorbells, smart locks, automated lighting, and full home automation — all controlled from your smartphone.',
    href: '/services/cybersecurity',
    tag: 'Residential',
    image: 'https://readdy.ai/api/search-image?query=smart%20home%20automation%20tablet%20app%20control%20security%20lights%20locks%20modern%20living%20room%20interior%20design%20bright%20clean%20technology%20residential&width=600&height=400&seq=svc-smart1&orientation=landscape',
  },
  {
    icon: 'ri-customer-service-2-fill',
    title: '24/7 Monitoring & Support',
    description: 'Optional professional monitoring plans and remote access so you can view your cameras from any device, anywhere in the world, at any time.',
    href: '/services/cybersecurity',
    tag: null,
    image: 'https://readdy.ai/api/search-image?query=security%20monitoring%20center%20professional%20technician%20watching%20CCTV%20screens%20modern%20office%20bright%20clean%20professional%20support%20center&width=600&height=400&seq=svc-monitor1&orientation=landscape',
  },
];

export default function ServicesOverview() {
  return (
    <section className="bg-white py-24 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-slate-100" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-slate-100" />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full text-orange-700 text-xs font-bold uppercase tracking-[0.2em] border border-orange-200 bg-orange-50 mb-4">
            Our Services
          </span>
          <h2 className="font-display text-4xl lg:text-5xl font-black text-slate-900 mb-4">
            Complete Security System Solutions
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            From a single doorbell camera to a full multi-site commercial surveillance system —
            we design, install, and support it all.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {services.map((service) => (
            <Link
              key={service.title}
              to={service.href}
              className="group rounded-2xl border border-slate-200 bg-white hover:border-orange-300 hover:shadow-md transition-all duration-300 cursor-pointer overflow-hidden"
            >
              {/* Service image */}
              <div className="relative h-44 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {service.tag && (
                  <div className="absolute top-3 right-3">
                    <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-orange-500 text-white">
                      {service.tag}
                    </span>
                  </div>
                )}
              </div>

              <div className="p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-orange-100 border border-orange-200 flex-shrink-0 group-hover:bg-orange-200 transition-colors">
                    <i className={`${service.icon} text-orange-600 text-lg`} />
                  </div>
                  <h3 className="font-display font-black text-slate-900 text-base group-hover:text-orange-600 transition-colors">
                    {service.title}
                  </h3>
                </div>
                <p className="text-slate-500 text-sm leading-relaxed mb-4">{service.description}</p>
                <div className="flex items-center gap-2 text-orange-600 text-sm font-bold">
                  <span>Learn More</span>
                  <div className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                    <i className="ri-arrow-right-line" />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Mid-page CTA */}
        <div className="rounded-2xl border border-slate-200 bg-slate-50 p-7 flex flex-col md:flex-row items-center justify-between gap-5">
          <div className="text-center md:text-left">
            <p className="text-slate-900 font-display font-black text-xl mb-1">
              Not sure what system you need?
            </p>
            <p className="text-slate-500 text-sm">
              Our security specialists assess your property for free and recommend the right solution.
            </p>
          </div>
          <div className="flex flex-wrap gap-3 flex-shrink-0">
            <Link
              to="#contact"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-slate-900 text-white font-black text-sm hover:bg-slate-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Schedule Free Assessment
              <i className="ri-arrow-right-line" />
            </Link>
            <a
              href="tel:+18005551234"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl border-2 border-slate-200 text-slate-700 font-bold text-sm hover:border-orange-300 hover:text-orange-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-orange-500" />
              Call (800) 555-1234
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
